module.exports = __webpack_public_path__ + "img/avatar.d8525382.jpg";